import {Button, Card, Divider, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {StyledCard, TagChip} from 'presentation/components';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {ConsultProtocolsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {ProtocolStatusEnum} from 'presentation/pages/private/consult-protocols/constants';
import {formatProtocolDate} from '../../../utils/formatProtocolDate';
import {ProtocolStatus} from '../../../components/Status';
import {ProtocolCardProps} from './types';
import {extractProtocolInfo} from '../../../utils/extractProtocolInfo';
import {StyledCardContent} from './styles';

const {seeMore} = translations['pt-br'].commons;
const {protocolLabel, requestDateLabel} = translations['pt-br'].privateFlow.consultProtocols;

export function ProtocolCard({protocol, handleViewMore}: ProtocolCardProps) {
	const theme = useTheme();
	const {isMobile, isLaptop} = useMediaQueries();
	const {protocolSummaryList} = extractProtocolInfo(protocol);
	const isStatusCompleted = protocol.statusDescricao === ProtocolStatusEnum.COMPLETED;

	return (
		<Card elevation={0}>
			<StyledCardContent>
				{isMobile ? null : (
					<Stack gap={1}>
						<Stack direction={isLaptop ? 'column' : 'row'} gap={1}>
							<Typography variant="body1" color="text.primary">
								{protocolLabel} <b>{protocol?.registro}</b>
							</Typography>
							<Stack direction="row" alignItems="center" gap={1}>
								<Divider orientation="vertical" flexItem />

								<Typography variant="body1" color="text.secondary">
									{requestDateLabel}
									{formatProtocolDate(protocol?.dtAtendimento)}
								</Typography>

								<Divider orientation="vertical" flexItem />
								<Typography variant="body2" color="text.secondary" lineHeight={1.5}>
									{protocol?.tipoProtocolo}
								</Typography>
							</Stack>
						</Stack>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent={
								protocol?.statusDescricao === null ? 'flex-end' : 'space-between'
							}>
							{protocol?.statusDescricao ? (
								<TagChip
									label={protocol.statusDescricao}
									color={isStatusCompleted ? 'success' : 'primary'}
								/>
							) : null}

							<Button
								data-tag-id={
									ConsultProtocolsTaggingEnum.CLICK_VER_MAIS_PROTOCOLO_LISTA_PROTOCOLOS
								}
								variant="text"
								size="medium"
								onClick={() => handleViewMore(protocol)}
								endIcon={
									<Icon
										name="chevron-right-outlined"
										color={theme.palette.primary.main}
										size={20}
									/>
								}>
								{seeMore}
							</Button>
						</Stack>
					</Stack>
				)}

				{isMobile ? (
					<Stack gap={1.5}>
						<ProtocolStatus protocol={protocol} />
						<Divider />
						<Stack gap={0.5}>
							<StyledCard.Content
								sx={{flexDirection: isMobile ? 'column' : 'row'}}
								list={protocolSummaryList}
							/>
							<Button
								variant="text"
								size="medium"
								onClick={() => handleViewMore(protocol)}
								sx={{alignSelf: 'flex-end'}}
								endIcon={
									<Icon
										name="chevron-right-outlined"
										color={theme.palette.primary.main}
										size={20}
									/>
								}>
								{seeMore}
							</Button>
						</Stack>
					</Stack>
				) : null}
			</StyledCardContent>
		</Card>
	);
}
